import { instanceOEF, segundaVersaoOEF, instanceApi } from './api'

export const listaInfosPagamento = idAssinatura => instanceApi.get( `v1/assinatura/${idAssinatura}/pagamento` )

export const cadastraNovaDataCobranca = novaData => instanceOEF.patch( `${segundaVersaoOEF}/assinatura`, novaData )
